export class Invoice {
    invoiceID: string;
    orderId: string;
    order: any;
    index: number;
}
